var switchStyleFn = function switchStyleFn(token) {
  return {
    // '.ant-switch.ant-switch-disabled,.ant-switch.ant-switch-loading': {
    //   opacity: 1,
    // },
    // '.ant-switch-disabled.ant-switch-checked': {
    //   backgroundColor: token.colorCheckDisabledBg,
    // },
    // '.ant-switch-disabled': {
    //   backgroundColor: token.colorDisabledBg,
    // },
    '.ant-switch-handle::before': {
      boxShadow: 'none'
    }
  };
};

export { switchStyleFn };
